import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "href", "description", "iconStart", "iconEnd", "onClick", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Link.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var BaseLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var title = _ref.title,
      href = _ref.href,
      description = _ref.description,
      IconStart = _ref.iconStart,
      IconEnd = _ref.iconEnd,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsxs(views.Wrapper, _objectSpread(_objectSpread({
    href: href,
    as: href ? "a" : "button",
    onClick: onClick,
    role: "menuitem"
  }, rest), {}, {
    children: [IconStart && _jsx(IconStart, {}), _jsxs("div", {
      children: [_jsxs(views.Title, {
        children: [_jsx(views.Link, _objectSpread(_objectSpread({
          variant: "pSmallBold",
          ref: ref
        }, tokens), {}, {
          children: title
        })), IconEnd && _jsx(IconEnd, {})]
      }), description && _jsx(views.Description, {
        variant: "textRegularSmall",
        children: description
      })]
    })]
  }));
});
var Link = withDesignTokens(BaseLink, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100],
    openColor: theme.palette.twilio.blue[60],
    lineColor: theme.palette.twilio.blue[60]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900],
      openColor: theme.palette.brand.segmentGreen[500],
      lineColor: theme.palette.brand.segmentGreen[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900],
      openColor: theme.palette.brand.segmentGreen[500],
      lineColor: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
export default Link;